/**
 * @flow
 * @relayHash 180ff7528a94c524c204237d3cba16a1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EstimateContainer_node$ref = any;
type EstimateContainer_viewer$ref = any;
export type DocumentRoutes_Estimate_QueryVariables = {|
  id: string
|};
export type DocumentRoutes_Estimate_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: EstimateContainer_node$ref
  |},
  +viewer: ?{|
    +$fragmentRefs: EstimateContainer_viewer$ref
  |},
|};
export type DocumentRoutes_Estimate_Query = {|
  variables: DocumentRoutes_Estimate_QueryVariables,
  response: DocumentRoutes_Estimate_QueryResponse,
|};
*/


/*
query DocumentRoutes_Estimate_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...EstimateContainer_node
    id
  }
  viewer {
    ...EstimateContainer_viewer
    id
  }
}

fragment EstimateContainer_node on Estimate {
  id
  title
  notes
  can_edit
  can_email
  share_token
  brand_logo_url
  brand_header
  recipient_first_name
  recipient_last_name
  recipient_company_name
  recipient_email
  recipient_phone
  recipient_address
  hide_total
  estimate_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  estimate_line_items(first: 99999) {
    edges {
      node {
        id
        description
        position
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  workspaces {
    edges {
      node {
        id
        event {
          id
          ...Share_event
        }
      }
    }
  }
}

fragment EstimateContainer_viewer on User {
  id
  first_name
  last_name
  s_time_zone
  ...AvailabilityCalendarContainer_viewer
  ...ScheduleContainer_viewer
  primary_brand {
    id
  }
  features {
    hide_estimate_total
    id
  }
  ...LibraryContainer_viewer
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ScheduleContainer_viewer on User {
  id
  s_time_zone
  ...AvailabilityCalendarContainer_viewer
}

fragment LibraryContainer_viewer on User {
  id
  user_line_items(first: 99999) {
    edges {
      node {
        id
        description
        price_cents
        price_currency
        quantity
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment Share_event on Event {
  user_contacts {
    edges {
      node {
        first_name
        last_name
        user_contact_emails {
          edges {
            node {
              address
              id
            }
          }
        }
        id
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 99999,
  "type": "Int"
},
v7 = [
  v6
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "all_day",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "location",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "room",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price_cents",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price_currency",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DocumentRoutes_Estimate_Query",
  "id": null,
  "text": "query DocumentRoutes_Estimate_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...EstimateContainer_node\n    id\n  }\n  viewer {\n    ...EstimateContainer_viewer\n    id\n  }\n}\n\nfragment EstimateContainer_node on Estimate {\n  id\n  title\n  notes\n  can_edit\n  can_email\n  share_token\n  brand_logo_url\n  brand_header\n  recipient_first_name\n  recipient_last_name\n  recipient_company_name\n  recipient_email\n  recipient_phone\n  recipient_address\n  hide_total\n  estimate_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  estimate_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        position\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  workspaces {\n    edges {\n      node {\n        id\n        event {\n          id\n          ...Share_event\n        }\n      }\n    }\n  }\n}\n\nfragment EstimateContainer_viewer on User {\n  id\n  first_name\n  last_name\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer\n  ...ScheduleContainer_viewer\n  primary_brand {\n    id\n  }\n  features {\n    hide_estimate_total\n    id\n  }\n  ...LibraryContainer_viewer\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ScheduleContainer_viewer on User {\n  id\n  s_time_zone\n  ...AvailabilityCalendarContainer_viewer\n}\n\nfragment LibraryContainer_viewer on User {\n  id\n  user_line_items(first: 99999) {\n    edges {\n      node {\n        id\n        description\n        price_cents\n        price_currency\n        quantity\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Share_event on Event {\n  user_contacts {\n    edges {\n      node {\n        first_name\n        last_name\n        user_contact_emails {\n          edges {\n            node {\n              address\n              id\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DocumentRoutes_Estimate_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EstimateContainer_node",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EstimateContainer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DocumentRoutes_Estimate_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "InlineFragment",
            "type": "Estimate",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_last_name",
                "args": null,
                "storageKey": null
              },
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "share_token",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand_logo_url",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "brand_header",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_first_name",
                "args": null,
                "storageKey": null
              },
              v5,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_company_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_phone",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recipient_address",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hide_total",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "estimate_event_segments",
                "storageKey": "estimate_event_segments(first:99999)",
                "args": v7,
                "concreteType": "EstimateEventSegmentConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EstimateEventSegmentEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "EstimateEventSegment",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line1",
                            "args": null,
                            "storageKey": null
                          },
                          v3,
                          v8,
                          v9,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "time_zone",
                            "args": null,
                            "storageKey": null
                          },
                          v10,
                          v11,
                          v5,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "line2",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "city",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "province",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "postal_code",
                            "args": null,
                            "storageKey": null
                          },
                          v12,
                          v4,
                          v2
                        ]
                      },
                      v13
                    ]
                  },
                  v14
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "estimate_event_segments",
                "args": v7,
                "handle": "connection",
                "key": "EstimateContainer_estimate_event_segments",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "estimate_line_items",
                "storageKey": "estimate_line_items(first:99999)",
                "args": v7,
                "concreteType": "EstimateLineItemConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EstimateLineItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "EstimateLineItem",
                        "plural": false,
                        "selections": [
                          v3,
                          v15,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "position",
                            "args": null,
                            "storageKey": null
                          },
                          v16,
                          v17,
                          v18,
                          v5,
                          v2
                        ]
                      },
                      v13
                    ]
                  },
                  v14
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "estimate_line_items",
                "args": v7,
                "handle": "connection",
                "key": "EstimateContainer_estimate_line_items",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workspaces",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkspaceConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkspaceEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Workspace",
                        "plural": false,
                        "selections": [
                          v3,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "event",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Event",
                            "plural": false,
                            "selections": [
                              v3,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "user_contacts",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "EventUserContactConnectionWithRole",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "EventUserContactEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "UserContact",
                                        "plural": false,
                                        "selections": [
                                          v19,
                                          v20,
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user_contact_emails",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UserContactEmailConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "edges",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "UserContactEmailEdge",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "UserContactEmail",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "address",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      v3
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          v3
                                        ]
                                      },
                                      v3
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v3,
          v19,
          v20,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCalendarContainer_user_events",
            "name": "user_events",
            "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
            "args": [
              {
                "kind": "Literal",
                "name": "booking_status",
                "value": [
                  "BOOKED",
                  "INITIAL",
                  "CANCELED"
                ],
                "type": "[BookingStatus]"
              },
              v6,
              {
                "kind": "Literal",
                "name": "return_empty_connection",
                "value": true,
                "type": "Boolean"
              },
              {
                "kind": "Literal",
                "name": "visibility",
                "value": [
                  "SHOW"
                ],
                "type": "[UserEventVisibility]"
              }
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEvent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                          v3,
                          v5
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "booking_status",
                        "args": null,
                        "storageKey": null
                      },
                      v8,
                      v9,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_event_segments",
                        "storageKey": "user_event_segments(first:99999)",
                        "args": v7,
                        "concreteType": "UserEventSegmentConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserEventSegmentEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegment",
                                "plural": false,
                                "selections": [
                                  v5,
                                  v8,
                                  v9,
                                  v10,
                                  v11,
                                  v12,
                                  v3
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "primary_brand",
            "storageKey": null,
            "args": null,
            "concreteType": "Brand",
            "plural": false,
            "selections": [
              v3
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "features",
            "storageKey": null,
            "args": null,
            "concreteType": "Features",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hide_estimate_total",
                "args": null,
                "storageKey": null
              },
              v3
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_line_items",
            "storageKey": "user_line_items(first:99999)",
            "args": v7,
            "concreteType": "UserLineItemConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserLineItemEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserLineItem",
                    "plural": false,
                    "selections": [
                      v3,
                      v15,
                      v16,
                      v17,
                      v18,
                      v5,
                      v2
                    ]
                  },
                  v13
                ]
              },
              v14
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "user_line_items",
            "args": v7,
            "handle": "connection",
            "key": "LibraryContainer_user_line_items",
            "filters": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8ca5ee116c2531f140027a6c4be6dc40';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/DocumentRoutes_Estimate_Query.graphql.js